import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function HorizontalLinesIcon({
  className,
  color = "currentColor",
  fill,
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon fill={fill} size={size} className={className}>
      <path
        d="M4 6H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 18H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
